import React from 'react';
import ReactDOM from 'react-dom';
import AppRoot from './pages/AppRoot';
import './App.scss';

ReactDOM.render(<AppRoot />, document.getElementById('root'));
